/**
 * Get the corresponding risk score label.
 *
 * __> Example:__
 * ```ts
 * getRiskLabel(100);
 * // "critical"
 * ```
 */

export const getRiskLabel: GetRiskLabel = (riskScore) => {
  if (riskScore <= 30) return 'low';
  if (riskScore <= 60) return 'medium';
  if (riskScore <= 90) return 'high';

  return 'critical';
};

type GetRiskLabel = (
  riskScore: number,
) => 'low' | 'medium' | 'high' | 'critical';
